export default function ContactBar() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-primary-500 text-white py-3 px-4 md:px-8">
      <div className="flex items-center justify-center gap-6 md:gap-8 flex-wrap">
        <a href="tel:+5511985860949" className="flex items-center gap-2 text-sm font-medium hover:text-primary-100 transition-colors">
          <i className="ri-phone-line text-base"></i>
          <span className="hidden sm:inline">(11) 9.8586-0949</span>
          <span className="sm:hidden">Ligar</span>
        </a>
        <span className="hidden md:block w-px h-4 bg-primary-300"></span>
        <a
          href="https://wa.me/5511985860949"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 text-sm font-medium hover:text-primary-100 transition-colors"
        >
          <i className="ri-whatsapp-line text-base"></i>
          <span className="hidden sm:inline">WhatsApp</span>
          <span className="sm:hidden">WhatsApp</span>
        </a>
        <span className="hidden md:block w-px h-4 bg-primary-300"></span>
        <a
          href="mailto:contato@rcrednegocios.com.br"
          className="flex items-center gap-2 text-sm font-medium hover:text-primary-100 transition-colors"
        >
          <i className="ri-mail-line text-base"></i>
          <span className="hidden lg:inline">contato@rcrednegocios.com.br</span>
          <span className="lg:hidden">E-mail</span>
        </a>
      </div>
    </div>
  );
}